export default [
    "24 24",
  '<path d="M18 15L12 9L6 15" fill="none" class="stroke-over" stroke="var(--ci-primary-color, currentColor)"  stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
]